import { render, staticRenderFns } from "./BdrDictionarySidebar.vue?vue&type=template&id=5ccd9408&"
import script from "./BdrDictionarySidebar.vue?vue&type=script&lang=js&"
export * from "./BdrDictionarySidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports